import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * When Supabase redirects after email verification or magic link, it may send
 * the user to the site root (e.g. http://localhost:3000) with tokens in the
 * hash. Our app only processes the hash on /auth/callback. This component
 * redirects any path that has auth tokens in the hash to /auth/callback so
 * the session can be established and the user sent to the right place.
 */
export function AuthHashRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;

    const hasAuthParams =
      /access_token=/.test(hash) || /refresh_token=/.test(hash);
    if (!hasAuthParams) return;

    // Already on callback route; let AuthCallback handle it.
    if (location.pathname === '/auth/callback') return;

    navigate(`/auth/callback${hash}`, { replace: true });
  }, [location.pathname, navigate]);

  return null;
}
